import React from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import ModalHead from './ModalHead';
import {Play} from "./Inc";
import {Styles} from './Styles';
import {Tools} from './Tools';

interface Props {
    play:Play,
    uid:string,
    close(play:Play):void,
}

const Called = (props:Props)=> {
    const classes = Styles.base();
    const close = ()=>{
        props.close(props.play);
    }

    const title = Tools.roomName(props.play.floor_num,props.play.room_num) + "号室";

    return (
        <div id="room" className={classes.modalRoot}>
            <ModalHead title={title}/>
            {props.play.lover_nick!=="" ? (
                <div className={classes.room}>
                    窓に映る人影を見てとっさに声が出た<br/>
                    「{props.play.lover_nick}？」<br/>
                    もちろんそれは彼女ではなく自分の影だった<br/>
                </div>
            ):(
                <div className={classes.room}>
                    ベッドに座ってドアの方を見た瞬間にきみは思い出した<br/>
                    「{props.play.lover_name}」<br/>
                    それがきみを置いて出ていった少女の名前だ<br/>
                </div>
            )}

            <div className={classes.modalBottom}>
                <FormControl fullWidth={true} className={classes.formControl}>
                    <Button variant="outlined" color="primary" onClick={close} style={{marginBottom:"0.2em"}}>OK</Button>
                </FormControl>
            </div>
        </div>
    );
}

export default Called;
